import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPisoDeckSintetico from '../components/sections/PisoDeckSintetico/TituloPisoDeckSintetico';
import IntroPisoDeckSintetico from '../components/sections/PisoDeckSintetico/IntroPisoDeckSintetico';
import VentajasPisoDeckSintetico from '../components/sections/PisoDeckSintetico/VentajasPisoDeckSintetico';
import FormularioContactoDeck from '../components/sections/PisoDeckSintetico/FormularioContactoDeck';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer'; 

const PisoDeckSinteticoPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Piso Deck Sintético | Decototal"
        description="Conoce el piso deck sintético para terrazas y exteriores: una alternativa práctica y decorativa. Revisa sus ventajas y solicita una cotización."
        keywords="piso deck sintético, deck para exterior, piso para terraza, deck WPC"
        path="/piso-deck-sintetico-page"
        image="/assets/img/productos/piso-deck-sintetico/piso-deck-sintetico-titulo.jpg"
      />
      <Header />
        <TituloPisoDeckSintetico />  
        <IntroPisoDeckSintetico /> 
        <VentajasPisoDeckSintetico /> 
        <FormularioContactoDeck />
      <Footer />
    </div>
  );
};

export default PisoDeckSinteticoPage;